

document.querySelector(".popup-btn").addEventListener('click', function (e) {
e.stopPropagation();
document.querySelector(".popup").style.display = 'block';
}, false);


document.querySelector(".popup-btn").addEventListener('click', function () {
document.querySelector(".popup-overlay").style.display = 'block';
}, false);


document.querySelector(".popup-close").addEventListener('click', function () {
document.querySelector(".popup").style.display = 'none';
document.querySelector(".popup-overlay").style.display = 'none';
}, false);


document.querySelector("body").addEventListener('click', function () {
document.querySelector(".popup").style.display = 'none';
document.querySelector(".popup-overlay").style.display = 'none';
}, false);


document.querySelector(".popup").addEventListener('click', function (e) {
e.stopPropagation();
}, false);


    

window.addEventListener("load", function(){
//setTimeout() method sets a timer which executes a function once the timer expires
    setTimeout(
        function open(event){
          let show_popup = checkCookie();
          if (show_popup){
            document.querySelector(".popup-overlay").style.display = "block";
          	document.querySelector(".popup").style.display = "block";
          }
        },
        2000 // 1 seconds = 1000 milliseconds
    )
});
//Activate the cancel button
document.querySelector(".popup-close").addEventListener("click", function(){
    document.querySelector(".popup").style.display = "none";
});

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}
function checkCookie() {
  let avoid_popup = getCookie("avoid_popup");
  if (avoid_popup != '') {
    return false;
  }else{
    setCookie("avoid_popup", true, 30);
    return true;
  }
}
